import React, { CSSProperties, useMemo } from 'react'
import './Modal.scss'
import { AnimatedFragment } from '../Animator/AnimatedFragment'
import { useTranslation } from 'react-i18next'

interface IProps {
  /** Modal is visible */
  visible?: boolean
  /** On close button was pressed */
  onClose: () => void
  /** Content of modal window */
  children: React.ReactNode
  /** Content is loading */
  loading?: boolean
  /** Content of modal footer */
  footer?: React.ReactNode
  /** Title */
  title?: string
  /** Icon */
  icon?: string
  /** Close icon is hidden. False by default. */
  hideCloseIcon?: boolean
  /** Modal container styles. */
  styles?: CSSProperties
  resetBtn?: boolean
  resetOrder?: () => void
}

export const Modal = (props: IProps) => {
  const { t } = useTranslation()

  const styles = useMemo(() => {
    const newStyles = {
      // New styles.
      ...props.styles,
    }

    return newStyles
  }, [props.styles])

  const showTitleHeader = !!props.icon || !!props.title
  const resetButton = !!props.resetBtn && !!props.resetOrder && (
    <div className="rightFilters">
      <a onClick={() => props.resetOrder && props.resetOrder()}>
        <span className="icon-eye"></span>
        <i className="icon-clear"></i> <span>{t('RESTORE_DEFAULT')}</span>
      </a>
    </div>
  )

  const header = showTitleHeader && !props.hideCloseIcon && (
    <div className="box-title relative" style={resetButton ? { display: 'flex' } : undefined}>
      <span>
        <i className={props.icon}></i>
        {props.title}
      </span>
      {resetButton}

      <button title={t('CLOSE') || 'close'} className="close" onClick={props.onClose}>
        <i className="icon-close" />
      </button>
    </div>
  )

  /**
   * The close button.
   */
  const closeIcon = !showTitleHeader && !props.hideCloseIcon && (
    <div className="relative">
      <button title={t('CLOSE') || 'close'} className="close" onClick={props.onClose}>
        <i className="icon-close" />
      </button>
    </div>
  )

  return (
    <AnimatedFragment visible={props.visible} className="modal-background" type={'fade'} onMouseDown={props.onClose}>
      <div className="modal-body" onMouseDown={(e) => e.stopPropagation()} style={styles}>
        {header}
        {closeIcon}
        <div className="modal-container">
          <AnimatedFragment className="full-width" loading={props.loading} type={'fade-rubber'} visible>
            {props.children}
          </AnimatedFragment>
        </div>
        {!!props.footer && <div className="modal-container">{props.footer}</div>}
      </div>
    </AnimatedFragment>
  )
}
